$(document).ready(function () {
  $('.swatch-element').click(function () {
    $('.product-form__inventory-icon-status.text-success').hide();
    setTimeout(() => {
      $('.product-form__inventory-icon-status.text-success').show();
    }, 200);
    setTimeout(() => {
      if ($('.product-form').hasClass('product-form--variant-sold-out')) {
        $('.hover_custom').hide();
        let $button = $('.product-form--variant-sold-out .js-product-form__cart-submit');

        $('.js-product-form__cart-submit').find('span[data-add-to-cart-text]').text('Contact for availability');
        $button.removeAttr('aria-disabled');
        $button.off('click').on('click', function (e) {
          e.preventDefault();
          let productTitle = encodeURIComponent($(this).attr('data-product-title'));
          let productLink = encodeURIComponent(window.location.origin + $(this).attr('data-product-link'));
          let productVariant = encodeURIComponent($(this).attr('data-product-variant') || 'default-variant');
          //window.location.href = `https://greenhatkiteboarding.com/pages/contact-form?product=${productTitle}&link=${productLink}`;
          window.location.href = `https://greenhatkiteboarding.com/pages/contact-form?product=${productTitle}&link=${productLink}&variant=${productVariant}`;
        });
      } else {
        $('.hover_custom').show();
        $('.js-product-form__cart-submit').find('span[data-add-to-cart-text]').text('Add to cart');
        $('.product-form__inventory-icon-status load-icon').html(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="icon"><!--! Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path></svg>',
        );
        $('.js-product-form__cart-submit').off('click');
      }
    }, 200);
  });

  $(document).ready(function () {
    function getQueryParam(name) {
      let urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    let productName = getQueryParam('product');
    let productLink = getQueryParam('link');
    let productvariant = getQueryParam('variant');

    if (productName && productLink) {
      let message = `I am inquiring about the availability of the following product:\n${decodeURIComponent(productName)}\n${decodeURIComponent(productvariant)}\n${decodeURIComponent(productLink)}\n`;

      $(".contact-form textarea[name='contact[Message]']").val(message);
    }
  });
});

$(window).on('load', function () {
  if ($('.product-form').hasClass('product-form--variant-sold-out')) {
    $('.hover_custom').hide();
    $('.js-product-form__cart-submit').find('span[data-add-to-cart-text]').text('Contact for availability');
  } else {
    $('.hover_custom').show();
    $('.product-form__inventory-icon-status load-icon').html(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="icon"><!--! Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2024 Fonticons, Inc. --><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path></svg>',
    );
    $('.product-form__inventory-icon-status.text-success').show();
  }

  // let currentUrl = window.location.href;

  // if (currentUrl.includes("/a/")) {
  // let newUrl = currentUrl.replace("/a/", "/");
  // window.location.replace(newUrl);
  // $(".search-page-wrapper .text-center h1").text("");
  // }
});

$(document).ready(function () {
  function adjustMargin() {
    var headerHeight = $('.js-site-header').outerHeight();
    $('#PageContainer').css('margin-top', headerHeight + 'px');
  }

  adjustMargin();

  $(window).resize(function () {
    adjustMargin();
  });
});

$(document).ready(function () {
  function getVariantId($scope) {
    const raw = $scope.attr('data-product');
    if (!raw) return null;

    let product;
    try {
      product = JSON.parse(raw);
    } catch {
      console.error('Invalid product JSON');
      return null;
    }

    const selectedOptions = $scope
      .find('input[type="radio"][name^="option-"]:checked')
      .map(function () {
        return $(this).val().trim();
      })
      .get();

    if (product.variants.length === 1 && product.options.length <= 1) {
      return product.variants[0].id;
    }

    if (product.options.length === 0 || selectedOptions.length === 0) {
      return product.variants.length === 1 ? product.variants[0].id : null;
    }

    const matched = product.variants.find((variant) => {
      return variant.options.length === selectedOptions.length && variant.options.every((opt, i) => opt === selectedOptions[i]);
    });

    return matched ? matched.id : null;
  }

  function getQuantity($scope) {
    const $qtyInput = $scope.find('.qty_container input[name="quantity"]');
    const qty = parseInt($qtyInput.val(), 10);
    return qty && qty > 0 ? qty : 1;
  }

  function updateVariantInput($scope) {
    const variantId = getVariantId($scope);
    const $input = $scope.find('.variant-id-input');

    if (variantId) {
      $input.val(variantId);
      console.log('Variant ID set:', variantId);
    } else {
      $input.val('');
      console.log('No matching variant found.');
    }
  }

  $(document).on('change', 'input[type="radio"][name^="option-"]', function () {
    const $scope = $(this).closest('.product-single__meta');
    setTimeout(() => updateVariantInput($scope), 100);
  });

  $(document).on('click', '.buy-with-now', function (event) {
    const $button = $(this);
    if ($button.hasClass('disabled')) {
      console.log('Buy Now is disabled due to max quantity.');
      return;
    }

    event.preventDefault();

    const $scope = $button.closest('.product-single__meta');
    const variantId = $scope.find('.variant-id-input').val();
    const quantity = getQuantity($scope);
    // Line item properties (pre-order date, bundle picks) from the product form.
    const properties = $button
      .closest('form')
      .serializeArray()
      .filter((field) => field.name.indexOf('properties[') === 0);

    if (!variantId) {
      console.log('No variant selected.');
      return;
    }

    $button.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: [{ name: 'quantity', value: quantity }, { name: 'id', value: variantId }].concat(properties),
      success: function () {
        window.location.href = '/checkout';
      },
      error: function (xhr) {
        if (xhr.status === 422 && xhr.responseText.includes('maximum quantity')) {
          console.warn('Maximum quantity already in cart.');
          $button.addClass('disabled').prop('disabled', true);
        } else {
          console.error('Add to cart failed:', xhr.responseText);
        }
      },
      complete: function () {
        if (!$button.hasClass('disabled')) {
          $button.prop('disabled', false);
        }
      },
    });
  });

  $('.product-single__meta').each(function () {
    updateVariantInput($(this));
  });

  // Pre-order variants: Buy Now reads "Pre-Order Now" and both buttons add a
  // "Pre-Order: Ships <date>" line item property.
  document.addEventListener('variantChange', function (event) {
    const variant = event.detail && event.detail.variant;
    const $section = $(event.target).closest('[data-section-type="product"]');
    const $json = $section.find('[data-preorder-json]');
    if (!variant || !$json.length) return;

    const shipDate = JSON.parse($json.text())[variant.id];
    $section.find('[data-buy-now-text]').text(shipDate ? 'Pre-Order Now' : 'Buy Now');
    $section
      .find('[data-preorder-property]')
      .val(shipDate ? 'Ships ' + shipDate : '')
      .prop('disabled', !shipDate);
  });
});
